<script lang="ts">
import type { GlobalFileId } from '#layers/data-model/public';
import type { LogoSize } from '#layers/ui/public';
import { tv } from 'tailwind-variants';
import { DynamicLogo, logoRadii, logoSizes } from '#layers/ui/public';
import RenderAssetImage from './RenderAssetImage.vue';

export interface BrandLogoProps {
	logoId?: GlobalFileId | null;
	color?: string | null;
	size?: LogoSize;
	class?: string;
}

const logo = tv({
	base: 'overflow-hidden',
	variants: {
		size: logoSizes,
		radius: logoRadii,
	},
	defaultVariants: {
		size: 'sm',
		radius: 'sm',
	},
});
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<BrandLogoProps>(), {
	size: 'sm',
});

const theme = computed(() => logo({ size: props.size, radius: props.size, class: props.class }));
const brandStyle = computed(() => (props.color ? { '--brand-color': props.color } : undefined));
</script>

<template>
	<div :class="theme">
		<DynamicLogo v-if="!logoId" :size :style="brandStyle" />
		<RenderAssetImage v-else :file="logoId" :workspace="false" class="size-full object-cover">
			<template #error>
				<DynamicLogo :size :style="brandStyle" />
			</template>
		</RenderAssetImage>
	</div>
</template>
